<template>
  <router-link :to="{ name: 'Profil' }">
    <div id="menuProgress">
      <div class="profileScore ">
        <div ref="fullBar" class="profileScoreProgress progressBar">
          <div v-bind:style="scoreStyle" class="progressBarInside" />
        </div>

        <div class="progressText">
          <label id="progressLabel"
            >Profil rempli à <span class="scoreProgressDesc">{{ score }}</span
            >%</label
          >
        </div>

        <div class="edit">
          <label>Editer mon profil</label>
        </div>
      </div>
      <div class="petitCadrePhoto">
        <Photo :profile="$store.state.profile" :pic="$store.state.profile.mainPicture"></Photo>
      </div>
    </div>
  </router-link>
</template>

<script>
import Photo from "@/components/profile/Photo";
import { idyuJsonRpc } from "@/assets/js/idyu/connect.js";

export default {
  components: { Photo },
  name: "MenuProgress",
  data() {
    return {
      score: 0
    };
  },

  computed: {
    scoreStyle: function() {
      const maxWidth = 140;
      const w = ((maxWidth - 2) * this.score) / 100;
      return { width: w + "px" };
    }
  },

  mounted: function() {
    this.updateScore();
  },

  methods: {
    updateScore: async function() {
      const result = await idyuJsonRpc("getProfileScore");
      this.score = result;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/vars.scss";

#menuProgress {
  display: grid;
  grid-template-columns: auto auto;
  font-size: 12px !important;
  border-left: $light_border;
  padding: 5px;
  padding-left: 10px;
  padding-right: 10px;
}

label {
  cursor: pointer;
}

#menuProgress .petitCadrePhoto {
  border-radius: 100%;
  margin-left: 5px;
}

.progressBar {
  width: 140px;
  height: 20px;
  position: relative;
  background-color: #efefed;
  border-width: 1px;
  border-style: solid;
  border-color: #888;
}

.progressBarInside {
  width: 0px;
  height: 18px;
  position: absolute;
  top: 1px;
  left: 1px;
  background-color: $theme_color;
}

.progressText {
  margin-top: 5px;
}

.progressLabel {
  font-weight: bold;
}

.scoreProgressDesc {
  font-weight: bold;
}

.edit {
  display: grid;
  grid-auto-flow: column;
  text-decoration: underline;
  font-style: italic;
}
</style>
